export default __webpack_public_path__ + "static/media/facebook.24894ee6.png";